<template>
  <div>
    <div
      v-if="customers.length === 0"
      class="text-center py-4 grey--text"
    >
      該当する顧客はいません
    </div>

    <v-chip-group
      v-else
      column
      class="customer-chip-group"
    >
      <v-chip
        v-for="customer in customers"
        :key="customer.id"
        outlined
        @click="handleCustomerClick(customer)"
      >
        <v-avatar
          left
          color="pink lighten-3"
          class="white--text"
        >
          {{ getInitial(customer.name) }}
        </v-avatar>
        {{ customer.name }}
        <span
          v-if="formatBirthday(customer.birthday)"
          class="ml-1 grey--text text--darken-1"
        >
          ({{ formatBirthday(customer.birthday) }})
        </span>
      </v-chip>
    </v-chip-group>
  </div>
</template>

<script>
import { mdiCake } from '@mdi/js'
import { format } from 'date-fns'

export default {
  name: 'CustomerUpcomingBirthdays',
  props: {
    customers: {
      type: Array,
      required: true,
    },
  },
  setup(props, { emit }) {
    const getInitial = name => {
      if (!name) return '?'

      return name.charAt(0)
    }

    const formatBirthday = dateString => {
      if (!dateString) return null
      try {
        return format(new Date(dateString), 'M/d')
      } catch (e) {
        return null
      }
    }

    const handleCustomerClick = customer => {
      emit('click', customer)
    }

    return {
      getInitial,
      formatBirthday,
      handleCustomerClick,
      icons: {
        mdiCake,
      },
    }
  },
}
</script>

<style scoped>
.customer-chip-group {
  max-height: 264px;
  overflow-y: auto;
}
</style>
